import styled from "styled-components";

import { theme } from "../../themes/themes";
export const GeneralStyle = styled.div`
  width: 100%;
  height: fit-content;
  padding: 2em;
  background-color: ${({ theme }) => theme.primaryBackgroundLight};
`;
export const ContentFields = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-gap: 1em;
  @media only screen and (max-width: 480px) {
    grid-template-columns: inherit;
  }
`;
export const ContentFile = styled.div`
  width: 100%;
  height: 12em;
  margin: auto;
`;
export const FieldFile = styled.div`
  height: 12em;
  display: grid;
  grid-auto-rows: 0em auto;
  label {
    color: rgb(143, 155, 179);
  }
`;
export const ContentButtons = styled.div`
  width: 19em;
  display: flex;
  grid-gap: 1em;
`;
export const ButtonCancel = styled.button`
  background: ${({ theme }) => theme.neutral.white};
  color: ${({ theme }) => theme.button.primary};
  font-size: 14px;
  font-weight: 500;
  border: 1px solid ${({ theme }) => theme.primary.purple};
  box-shadow: 0px 4px 18px ${({ theme }) => theme.shadows.medium};
  border-radius: 5px;
  width: 100%;
  height: 43.21px;
  &:hover {
    box-shadow: ${({ theme }) => theme.button.buttonHoverShadow};
    transform: translateY(-1px);
    cursor: pointer;
  }
`;
export const ButtonCreate = styled.button`
  background: ${({ theme }) => theme.button.primary};
  color: ${({ theme }) => theme.neutral.white};
  font-size: 14px;
  font-weight: 500;
  border: none;
  box-shadow: 0px 4px 18px ${({ theme }) => theme.shadows.medium};
  border-radius: 5px;
  width: 100%;
  height: 43.21px;
  &:hover {
    box-shadow: ${({ theme }) => theme.button.buttonHoverShadow};
    transform: translateY(-1px);
    cursor: pointer;
  }
`;
